/* eslint-disable import/no-named-default */
import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import 'isomorphic-fetch';
import '@babel/polyfill';

import layoutReducer from '../components/shared/layout/reducers';
import loggerMiddleware from '../../r/store/middleware/logger';
import featuresReducer from '../components/features/reducers';
import { default as report } from '../components/report';
import authReducer from '../components/auth/reducers';
import { getEnvironment } from '../../r/utils';

const inProduction = getEnvironment() === 'production';

export const combinedReducers = combineReducers({
  [report.constants.NAME]: report.reducers.default,
  features: featuresReducer,
  layout: layoutReducer,
  auth: authReducer
});

const store = configureStore({
  reducer: (state, action) => combinedReducers(state, action),
  devTools: !inProduction,
  preloadedState: {},
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: { ignoredActions: [] }
  }).concat(loggerMiddleware(inProduction)),
});

export default store;